import { render } from "./DeviceHelper.vue?vue&type=template&id=b2c5ec2a"
import script from "./DeviceHelper.vue?vue&type=script&lang=js"
export * from "./DeviceHelper.vue?vue&type=script&lang=js"

import exportComponent from "/home/omar/intouch-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress,QBtn});
